import styled from 'styled-components';
import { ThumbnailScroller } from 'styles';

export const Base = styled(ThumbnailScroller)``;
